export const trimScript = (script: string): string => {
  return script
    .replace(/[\r\n]+/g, ' ') // Replace line breaks with space
    .replace(/\s{2,}/g, ' ') // Collapse multiple spaces
    .trim(); // Trim leading and trailing spaces
};
